import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { CardHeader, Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import LinearDeterminate from "./LinearProgress";
import { fShortenNumber } from "../../Utils/formatNumber";
import generalFunc from "../../Utils/generalFunc";
import { useSelector } from "react-redux";
import moment from "moment";

function createData(
  name,
  cm,
  saed,
  loanpayment,
  amountpaid,
  targetdate,
  targetamount
) {
  return { name, cm, saed, loanpayment, amountpaid, targetdate, targetamount };
}


const rows = [
  createData(
    1,
    "Esther Johnson",
    "Fishery",
    45,
    "750000",
    "19 October, 2022",
    "150000"
  ),
  createData(
    2,
    "Yakubu Sani",
    "Fishery",
    20,
    "1050000",
    "9 December, 2022",
    "600000"
  ),
  createData(
    3,
    "Sharon Nwabueze",
    "Fishery",
    80,
    "900000",
    "1 October, 2022",
    "2800000"
  ),
];

export default function CMTable() {
  const loanStatusReducer = (state) => state.loanStatusReducer;
   const {
    allFetchedLoanBeneficiaries,
    
  } = useSelector(loanStatusReducer);


  // React.useEffect(()=>{
  //   console.log(allFetchedLoanBeneficiaries, "Ikow you get")
  // },[allFetchedLoanBeneficiaries])
  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        overflowX: "hidden",
        "&:hover": {
          overflowX: "auto",
          "&::-webkit-scrollbar": {
            width: 5,
            height: 5,
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#fff",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#DCDCDC",
            borderRadius: 2,
          },
        },
      }}
    >
      <Table aria-label="simple table">
        <TableHead style={{ height: "50px" }}>
          <TableRow>
            <TableCell>Corps Member</TableCell>
            <TableCell align="left">
              <Typography noWrap sx={{ fontSize: "14px" }}>
                Loan Payment
              </Typography>
            </TableCell>
            <TableCell align="left">
              <Typography noWrap sx={{ fontSize: "14px" }}>
                Amount Paid
              </Typography>
            </TableCell>
            <TableCell align="left">Target Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {allFetchedLoanBeneficiaries?.map((row) => (
            <TableRow
              key={row.name}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell align="left">
                <CardHeader
                  sx={{ p: 0 }}
                  avatar={
                    <Avatar
                      sx={{ width: 30, height: 30 }}
                      alt={row?.cmName}
                      src="/static/images/avatar/1.jpg"
                    />
                  }
                  title={
                    <Typography sx={{ fontSize: "14px" }} noWrap>
                      {row.cmName
}
                    </Typography>
                  }
                  subheader={row.saed}
                />
              </TableCell>
              <TableCell align="left">
                <CardHeader
                  sx={{ p: 0 }}
                  title={
                    <Typography noWrap style={{ fontSize: "10px" }}>
                      {row?.totalAmountPaidInPercent}%{" "}
                      <span>
                        {row?.totalAmountPaidInPercent && row?.totalAmountPaidInPercent > 70
                          ? "Almost Paid"
                          : "Pending"}
                      </span>
                    </Typography>
                  }
                  subheader={
                    <LinearDeterminate
                      progress={row?.totalAmountPaidInPercent}
                      colors="success"
                    />
                  }
                  titleTypographyProps={{
                    fontSize: 10,
                  }}
                  subheaderTypographyProps={{
                    fontSize: 12,
                    fontWeight: "550",
                    color: "#121212",
                  }}
                />
              </TableCell>
              <TableCell sx={{ width: "100px" }} align="left">
                <Typography
                  noWrap
                  sx={{
                    fontSize: "14px",
                    backgroundColor: "#F1F7F4",
                    padding: "10px",
                    color: "#016C34",
                  }}
                >
                  {" "}
                  {generalFunc.delimitNumber(row?.totalAmountPaid)}
                </Typography>
              </TableCell>
              <TableCell align="left">
                <CardHeader
                  sx={{ p: 0 }}
                  title={
                    <Typography noWrap style={{ fontSize: "10px" }}>
                      Until {moment(row?.loan?.expiryDate).format('Do MMMM YYYY')}
                    {/*   19 October 2022 */}
                    </Typography>
                  }
                  subheader={`₦ ${fShortenNumber(row?.loan?.amount)}`}
                  titleTypographyProps={{
                    fontSize: 10,
                  }}
                  subheaderTypographyProps={{
                    fontSize: 12,
                    fontWeight: "550",
                    color: "#121212",
                  }}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
